import { WIDGET_TYPES } from 'common/Widgets/constants';

export const OVERALL_VIEW_ID = -1;
export const OVERALL_VIEW_KEY = 'overall';

export const RECOMMENDATION_CATEGORIES = {
  rates: {
    label: 'Rates',
    value: 'rates',
    background: 'var(--light-green)',
    color: 'var(--positive-green)',
    gradientFrom: 'var(--mint-green)',
    gradientTo: 'var(--positive-green)',
  },
  sentiment: {
    label: 'Sentiment',
    value: 'sentiment',
    background: 'var(--peach-pale)',
    color: 'var(--inactive-orange)',
    gradientFrom: 'var(--amber-light)',
    gradientTo: 'var(--inactive-orange)',
  },
  occupancy: {
    label: 'Occupancy',
    value: 'occupancies',
    background: 'var(--background-gray-soft)',
    color: 'var(--neutral-category-text)',
    gradientFrom: 'var(--line-gray)',
    gradientTo: 'var(--line-gray-strong)',
  },
  incentives: {
    label: 'Incentives',
    value: 'incentives',
    background: 'var(--aqua-pale)',
    color: 'var(--turquoise)',
    gradientFrom: 'var(--turquoise-light)',
    gradientTo: 'var(--turquoise)',
  },
  fees: {
    label: 'Fees',
    value: 'fees',
    background: 'var(--lavender-soft)',
    color: 'var(--competitor-purple)',
    gradientFrom: 'var(--lavender-purple)',
    gradientTo: 'var(--competitor-purple)',
  },
  amenities: {
    label: 'Amenities',
    value: 'amenities',
    background: 'var(--faded-pink)',
    color: 'var(--hot-pink)',
    gradientFrom: 'var(--orchid-pink)',
    gradientTo: 'var(--hot-pink)',
  },
};

export const UNDEFINED_CATEGORY = {
  label: 'Undefined',
  background: 'var(--background-gray)',
  color: 'var(--neutral-category-text)',
  gradientFrom: 'var(--line-gray)',
  gradientTo: 'var(--line-gray-strong)',
};

export const CATEGORY_VALUE_WIDGETS = {
  pricing: [WIDGET_TYPES.MARKET_RATE_GRAPH],
  community_fee: [WIDGET_TYPES.COMMUNITY_FEES_GRAPH],
  occupancy: [WIDGET_TYPES.OCCUPANCY_GRAPH],
  care_level: [WIDGET_TYPES.CARE_FEES_GRAPH],
  review_score: [WIDGET_TYPES.RATING_GRAPH],
  review_text: [WIDGET_TYPES.REVIEWS],
  amenities: [WIDGET_TYPES.AMENITIES],
};
